export default __webpack_public_path__ + "static/1-8edaf88f56df725baac4eb081291e7a3.jpg";